/**
 * @desc 获取出库计划单sku明细
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.outPlanMaster.getOutPlanMastSkuDetail.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/outPlanMaster/getOutPlanMastSkuDetail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
